import { NumericOffIcon } from './NumericOffIcon';

/**
 * author: Piotr Ładoński
 * id 560615BB-A023-4B98-88A6-F38FBF3272E2
 * name numeric-off
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-off.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumbersOffIcon = NumericOffIcon;
export default NumbersOffIcon